<template>
    <div class="new_pol">
        <!-- <van-count-down v-if="type==='answerList'" class="" ref="countDown" :auto-start="false" :time="20000" format="ss s" @finish="finish()" /> -->
        <Swipe class="question-swipe" :loop="false" :show-indicators="false" :touchable=false ref="questionSwipe">
            <SwipeItem v-for="(item,key) in questions" :key="key">
                <div class="question-card " :class="{isanswered:type!=='answerList'}">
                    <div class="week clock" v-if="type==='answerList'">
                        选择题
                        <!-- <van-count-down ref="countDown" :auto-start="false" :time="20000" format="ss s" @finish="finish(item)" /> -->
                    </div>
                    <div class="title">
                        <div>NO.{{key+1}}</div>
                        <div>{{item.title}}</div>
                    </div>
                    <div class="isanswered_content" v-if="type!=='answerList'">
                        <div v-if="type ==='answered'">
                            <span></span>
                            <span>你已经完成了今日的答题</span>
                        </div>

                        <div v-else>
                            <span>你答对了{{answerInfo.correctcount}}题目</span>
                            <span>获得积分 {{answerInfo.score}}</span>
                        </div>
                        <!-- <div class="mvbutton" @click="goExchange">去兑换奖品</div> -->
                    </div>

                    <div v-for="(content,ckey) in item.content" :key="ckey"
                         class="question-item"
                         :class="{selected:item.selected===ckey+1,correct:(item.selected===ckey+1 && item.correct)||(cf.AesDecrypt(item.answer)*1===ckey+1 && !item.correct && item.selected!==undefined ),wrong:item.selected===ckey+1 && !item.correct}"
                         @click="selectAnswer(key,ckey)">
                        {{ckey|letters}}. {{content}}
                    </div>
                    <div class="result">
                        <div class="question-item" style="line-height: .75rem;" v-if="key!=0" @click="prev(item,key)">上一题</div>
                        <div class="question-item selected" style="line-height: .75rem;" v-if="key!=questions.length-1" @click="next(item,key)">下一题</div>
                        <div class="question-item selected" style="line-height: .75rem;" v-if="key==questions.length-1" @click="submit(item)">提交答案</div>
                    </div>

                </div>
            </SwipeItem>
        </Swipe>
    </div>
</template>
<script>
    import "./index.less"
    import {Swipe, SwipeItem,CountDown} from 'vant';

    export default {
        name: "Questions",
        props: {
            questions: Array,
            answerInfo:Object,
            type:String
        },
        data() {
            return {
                weekday: [],
                ckey: 0,
                key: 0,
                item: {}
            }
        },
        watch: {
            list: {
                deep: true,
                handler(val) {
                    this.setOptions(val);
                },
            },
        },
        methods: {
            finish() {
                if(this.item.selected == undefined){
                    if (this.cf.AesDecrypt(this.item.answer) == 1) {
                        this.ckey = 1
                    } else {
                        this.ckey = 0
                    }
                    this.selectAnswer(this.key,this.ckey)
                }
            },
            start() {
                this.$refs.countDown.start();
            },
            reset() {
                this.$refs.countDown.reset();
            },
            prev(item,key) {                
                if(item.selected !== undefined){
                    this.$refs.questionSwipe.prev()
                } else {
                    this.$toast.fail("请先回答")
                    return;
                }
            },
            next(item,key) {
                if(item.selected !== undefined){
                    this.$refs.questionSwipe.next()
                    this.key = key+1
                    this.item = this.questions[key+1]
                    // if(this.item.selected == undefined) {
                    //     this.reset()                 
                    //     this.start()
                    // }                        
                } else {
                    this.$toast.fail("请先回答")
                    return;
                }
            },
            goExchange(){
              this.$router.push({name:'exchange'})
            },
            submit(item){
                if(item.selected !== undefined){
                    this.$emit('submitAnswer');
                } else {
                    this.$toast.fail("请先回答")
                    return;
                }                
            },
            selectAnswer(key, ckey) {
                // this.$refs.countDown.pause();
                let isselected = this.questions[key].selected !== undefined
                let selectanswer = this.questions[key]['content'][ckey]
                // this.$emit('selectAnswer', key, ckey);
                // if (selectanswer.length > 13) {
                //     this.$dialog.confirm({
                //         confirmButtonText: isselected ? "知道了" : "确认选择",
                //         message: selectanswer,
                //         showCancelButton: !isselected
                //     }).then(() => {
                //         if (isselected) return;
                //         this.$emit('selectAnswer', key, ckey);
                //         // on confirm
                //     }).catch(() => {
                //         // on cancel
                //     });
                // } else {
                //     if (isselected) return;
                //     this.$emit('selectAnswer', key, ckey);
                // }

                if (isselected) return;
                this.$emit('selectAnswer', key, ckey);
                // alert(1);
            }
        },
        filters: {
            letters(e) {
                let lettersarr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L']
                return lettersarr[e];
            }
        },
        components: {
            Swipe,
            SwipeItem,
            vanCountDown: CountDown
        },
        mounted() {
            let d = new Date();
            let weekday = new Array(7);
            weekday[0] = ['Sun.', '星期日'];
            weekday[1] = ['Mon.', '星期一'];
            weekday[2] = ['Tues.', '星期二'];
            weekday[3] = ['Wed.', '星期三'];
            weekday[4] = ['Thur.', '星期四'];
            weekday[5] = ['Fri.', '星期五'];
            weekday[6] = ['Sat.', '星期六'];

            this.weekday = weekday[d.getDay()];
            if(this.questions.length){
                if (this.questions[0].answer == 1) {
                    this.ckey = 1
                } else {
                    this.ckey = 0
                }
                this.item = this.questions[0]
                // if(this.type=='answerList' && this.item.selected == undefined) {
                //     this.$refs.countDown.start();
                // }
             }
             
            console.log(this.questions)

        }
    }
</script>
